import React, { useState } from 'react';
import Layout from '../../CommonComponents/Layout/Layout';
import { SIDER_TABS } from '../../../utils/Constants';
import './stylesMainSportsbook.css';
import SportsbookMainTabs from './SportsbookMainTabs/SportsbookMainTabs';
import PopularSPGs from './PopularSGPs/PopularSPGs';

function MainSportsbook() {
  const [activeTab, setActiveTab] = useState('Popular SPGs');

  const handleTabChange = (tabName) => {
    setActiveTab(tabName);
  };

  return (
      <Layout name={SIDER_TABS?.MAIN_SPORTSBOOK}>
        <div className="main-sportsbook-body-container">
          <div className="main-sportsbook-table" style={{ width: '100%' }}>
            <SportsbookMainTabs activeTab={activeTab} setActiveTab={handleTabChange} />
            {activeTab === 'Popular SPGs' && <PopularSPGs />}
          </div>
        </div>
      </Layout>
  );
}

export default MainSportsbook;
